import { CalendarDate, getLocalTimeZone, today } from "@internationalized/date";

const DateTimeUtils = () => ({
  get today() {
    const now = today(getLocalTimeZone());
    const date = new CalendarDate(now.year, now.month, now.day);

    return date.toString();
  },
  get tomorrow() {
    const now = today(getLocalTimeZone());
    const tomorrow = now.add({ days: 1 });
    const date = new CalendarDate(tomorrow.year, tomorrow.month, tomorrow.day);

    return date.toString();
  }
});

export default DateTimeUtils;
